export default "__VITE_ASSET__D$npWh7w__"